<mat-card style="padding: 0.5in;">

<div class="row" style="margin-bottom: 20px;">
  <div class="col-sm-6" style="text-align: left;">
    <button mat-raised-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
  <div class="col-sm-6" style="text-align: right;">
    <button mat-raised-button color="primary" (click)="printReport()">
      <mat-icon>print</mat-icon>
      Print Report
    </button>
  </div>
</div>

<kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="0.25in"
    [forcePageBreak]="'.page-break-before'">

  <div style="padding: 0.25in;">

    <div class="row">
      <div class="col-sm-12" style="text-align:center">
        <span class="text-primary" style="font-size: 30px; color:green">{{ feeModel.title }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="text-align:center">
        <span class="text-primary" style="font-size: 24px; color:green">Orelap ID: {{orelapId}} - 
          Laboratory : {{ feeModel.labName }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="text-align:center">
        <span class="text-primary" style="font-size: 20px; color:green">Application ID: {{ appId }} - 
          Application Type : {{ feeModel.applicationType }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="border-top: 1px; border-top:solid"></div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <span style="font-size: larger"><strong>User: {{ feeModel.user }}</strong></span>
      </div>
      <div class="col-sm-6" style="text-align: center">
        <span style="font-size: x-large; color: #dc3545 !important;">NOT an Invoice. Estimate ONLY</span>
      </div>
      <div class="col-sm-3">
        <span style="font-size: larger" class="pull-right"><strong>Date {{now}}</strong></span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12" style="border-bottom: 1px; border-bottom:solid"></div>
    </div>
    <br/>
    <div class="row">
      <div class="col-sm-12" style="text-align: center">
        <span><strong>Scope of Accreditation</strong></span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <table class="table w-full" >
          <tr class="backColor">
            <th class="w-1/2">Field of Testing</th>
            <th class="w-1/2">Matrix</th>
          </tr>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <ng-container *ngFor="let fee of groupedFees">
          <table class="table" style="page-break-inside:avoid">
            <tr>
              <th class="col-sm-4" style="background-color: #b5b3b3; border-top: none">{{ fee.complexity }}</th>
              <th class="col-sm-1" style="background-color: #b5b3b3; border-top: none">Cost</th>
              <th class="col-sm-1" style="background-color: #b5b3b3; border-top: none">Air</th>
              <th class="col-sm-1" style="background-color: #b5b3b3; border-top: none">Drinking Water</th>
              <th class="col-sm-2" style="background-color: #b5b3b3; border-top: none">Non-Potable Water</th>
              <th class="col-sm-1" style="background-color: #b5b3b3; border-top: none">Solids</th>
              <th class="col-sm-1" style="background-color: #b5b3b3; border-top: none">Biological Tissue</th>
              <th class="col-sm-1" style="background-color: #b5b3b3; border-top: none">Total Cost*</th>
            </tr>
            <ng-container *ngFor="let feeItem of fee.fot">
              <tr>
                <td style="border-top: none">{{ feeItem.fieldOfTesting }}</td>
                <td style="text-align: right;border-top: none">{{ feeItem.cost | currency }}</td>
                <td style="text-align: center; border-top: none">{{ feeItem.air }}</td>
                <td style="text-align: center; border-top: none">{{ feeItem.drinkingWater }}</td>
                <td style="text-align: center; border-top: none">{{ feeItem.nonPotable }}</td>
                <td style="text-align: center; border-top: none">{{ feeItem.solids }}</td>
                <td style="text-align: center; border-top: none">{{ feeItem.biological }}</td>
                <td style="text-align: right;border-top: none">{{ feeItem.fieldOfTestingSubtotal | currency }}</td>
              </tr>
            </ng-container>
            <tr>
              <td colspan="4"></td>
              <td><strong>Total FOTs</strong></td>
              <td><strong>{{ fee.fot.length }}</strong></td>
              <td><strong>Subtotal</strong></td>
              <td style="text-align: right;"><strong>{{ feeSummary(fee.fot) | currency }}</strong></td>
            </tr>
          </table>
          <br/>
        </ng-container>
      </div>
    </div>
<br/>
<br/>
    <div class="row page-break-before"></div>
    <div class="row">
      <div class="col-sm-6">
        <table class="table w-full" style="border: 1px solid black;">
          <thead>
            <tr>
              <th class="cellBorder"></th>
              <th class="backColor cellBorder" >Field of Testing</th>
              <th class="backColor cellBorder">Multiplier</th>
              <th class="backColor cellBorder">Points</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="cellBorder">Basic</th>
              <th class="cellBorder">{{feeModel.basicFots}}</th>
              <th class="cellBorder">{{feeModel.basicMultiplier}}</th>
              <th class="cellBorder">{{feeModel.basicFots * feeModel.basicMultiplier}}</th>
            </tr>
            <tr>
              <th class="cellBorder">Moderate</th>
              <th class="cellBorder">{{feeModel.moderateFots}}</th>
              <th class="cellBorder">{{feeModel.moderateMultiplier}}</th>
              <th class="cellBorder">{{feeModel.moderateFots * feeModel.moderateMultiplier}}</th>
            </tr>
            <tr>
              <th class="cellBorder">Complex</th>
              <th class="cellBorder">{{feeModel.complexFots}}</th>
              <th class="cellBorder">{{feeModel.complexMultiplier}}</th>
              <th class="cellBorder">{{feeModel.complexFots * feeModel.complexMultiplier}}</th>
            </tr>
            <tr>
              <th class="cellBorder">Advanced</th>
              <th class="cellBorder">{{feeModel.advancedFots}}</th>
              <th class="cellBorder">{{feeModel.advancedMultiplier}}</th>
              <th class="cellBorder">{{feeModel.advancedFots * feeModel.advancedMultiplier}}</th>
            </tr>
            <tr>
              <th class="cellBorder">Misc</th>
              <th class="cellBorder">{{feeModel.miscFots}}</th>
              <th class="cellBorder">{{feeModel.miscMultiplier}}</th>
              <th class="cellBorder">{{feeModel.miscFots * feeModel.miscMultiplier}}</th>
            </tr>
            <tr>
              <th class="cellBorder"></th>
              <th class="cellBorder"><strong>Total Points</strong></th>
              <th class="cellBorder"></th>
              <th class="cellBorder">
                <strong>
                  {{feeModel.basicFots * feeModel.basicMultiplier +
                  feeModel.moderateFots * feeModel.moderateMultiplier +
                  feeModel.complexFots * feeModel.complexMultiplier +
                  feeModel.advancedFots * feeModel.advancedMultiplier +
                  feeModel.miscFots * feeModel.miscMultiplier}}
                </strong>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-1"></div>
      <div class="col-sm-5">
        <table class="table cellBorder w-full">
          <thead>
            <tr>
              <th class="backColor cellBorder">Level</th>
              <th class="backColor cellBorder">Total Points</th>
              <th class="backColor cellBorder">Application Fee</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cellBorder">Tier 1</td>
              <td class="cellBorder">1 - 10</td>
              <td class="cellBorder">{{feeModel.feeTier1 | currency:'USD':'symbol':'1.2-2'}}</td>
            </tr>
            <tr>
              <td class="cellBorder">Tier 2</td>
              <td class="cellBorder">11 - 25</td>
              <td class="cellBorder">{{feeModel.feeTier2 | currency:'USD':'symbol':'1.2-2'}}</td>
            </tr>
            <tr>
              <td class="cellBorder">Tier 3</td>
              <td class="cellBorder">26 or 40</td>
              <td class="cellBorder">{{feeModel.feeTier3 | currency:'USD':'symbol':'1.2-2'}}</td>
            </tr>
            <tr>
              <td class="cellBorder">Tier 4</td>
              <td class="cellBorder">40 or 55</td>
              <td class="cellBorder">{{feeModel.feeTier4 | currency:'USD':'symbol':'1.2-2'}}</td>
            </tr>
            <tr>
              <td class="cellBorder">Tier 5</td>
              <td class="cellBorder"> >56</td>
              <td class="cellBorder">{{feeModel.feeTier5 | currency:'USD':'symbol':'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br/>
    <div class="row">
      <div class="col-sm-2 cellBorder">Application Fee</div>
      <div class="text-align: center;col-sm-2 cellBorder">{{feeModel.applicationFee | currency:'USD':'symbol':'1.2-2'}}</div>
      <div class="col-sm-2 cellBorder">Assessment Fee</div>
      <div class="text-align: center;col-sm-2 cellBorder">{{feeModel.assessmentFee | currency:'USD':'symbol':'1.2-2'}}</div>
      <div class="col-sm-2 cellBorder">Total</div>
      <div class="text-align: center;col-sm-2 cellBorder">{{(feeModel.applicationFee + feeModel.assessmentFee) | currency:'USD':'symbol':'1.2-2'}}</div>
    </div>

    <br/>
    <div class="row">
      <div class="col-sm-12">
        <span class="text-danger pull-right" style="font-size: x-large">NOT an Invoice. Estimate ONLY</span>
      </div>
    </div>

    <br/>
    <div class="row">
      <div class="col-sm-12">
        <span style="font-size:larger">* Fee Assessment</span><br />
        <span style="font-size:larger">** Additional Parameter point count only reflect application points not total lab points.</span><br />
        <span style="font-size:larger">Only considers NEW FOTs for On Site Assessment.</span>
        <span style="font-size:larger">Considers New Matrices for Document Assessment only.</span>
      </div>
    </div>
  </div>

</kendo-pdf-export>
</mat-card>